import * as React from "react";

import NavRailMenuItem from "./NavRailMenuItem";

import useRepoLinks from "hooks/useRepoLinks";

import SettingsIcon from "assets/svg/settings.svg";

const NavRailTail = () => {
  const { systemLink } = useRepoLinks();

  return (
    <NavRailMenuItem
      link={systemLink}
      title="System"
      Icon={SettingsIcon}
      className="nav-rail-tail"
      permission="ui_view_settings"
    />
  );
};

NavRailTail.propType = {};

export default NavRailTail;
